export default {
  title: 'Udsolgte varer',
  sections: {
    settings: 'Indstillinger',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Udsolgte varer markeres automatisk som tilgængelige igen ved dagens afslutning.',
        manual_reset: 'Personalet skal markere varer som tilgængelige igen, efter at de er markeret som udsolgt.',
      },
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
